import type { Outlet } from "../types/cafe";

export const outlets: Outlet[] = [
  {
    id: "scbd",
    name: "SCBD",
    area: "Jakarta Selatan",
    address: "SCBD Park, Jl. Jend. Sudirman Kav. 52–53, Senayan, Kebayoran Baru",
    vibe: "Suasana Taman",
    description:
      "Outlet andalan kami: kios beratap jerami di antara pohon palem, dikelilingi gedung pencakar langit dan area duduk terbuka.",
    image: "https://cdn.magicpatterns.com/uploads/2je6jkvZSqNfxZcSun96As/images.jpg",
    features: ["Area duduk taman terbuka", "Parkir sepeda", "Ramah hewan peliharaan", "Dekat perkantoran SCBD"],
    openHour: 7,
    closeHour: 21,
    hoursLabel: "Setiap hari 07.00–21.00",
  },
  {
    id: "cikajang",
    name: "Cikajang",
    area: "Kebayoran Baru",
    address: "Jl. Cikajang No. 12, Petogogan, Kebayoran Baru",
    vibe: "Titik Temu Strategis",
    description:
      "Hanya beberapa menit dari Senopati. Booth yang tenang dan ruang meeting yang bisa dipesan untuk maksimal delapan orang.",
    image: "https://cdn.magicpatterns.com/uploads/1GmWpw1zrK3kGrXAXfib3D/images_(2).jpg",
    features: ["Ruang meeting (8 orang)", "Wi‑Fi cepat", "Colokan di setiap kursi", "Layanan valet"],
    openHour: 7,
    closeHour: 21,
    hoursLabel: "Setiap hari 07.00–21.00",
  },
  {
    id: "tebet",
    name: "Tebet",
    area: "Jakarta Selatan",
    address: "Jl. Tebet Raya No. 88, Tebet Timur",
    vibe: "Pusat Komunitas",
    description:
      "Selangkah dari Tebet Eco Park. Meja komunal panjang, perpustakaan board game, dan Board Game Night setiap Jumat.",
    image: "https://cdn.magicpatterns.com/uploads/fDFxjaJ28QTo9TcsBxgQpC/images_(1).jpg",
    features: ["Perpustakaan board game", "Meja komunal", "Dekat Tebet Eco Park", "Area duduk outdoor"],
    openHour: 7,
    closeHour: 21,
    hoursLabel: "Setiap hari 07.00–21.00",
  },
  {
    id: "fatmawati",
    name: "Fatmawati",
    area: "Jakarta Selatan",
    address: "Jl. RS Fatmawati Raya No. 21, Cilandak",
    vibe: "Mampir Cepat Komuter",
    description:
      "Tepat di pintu keluar MRT Haji Nawi. Konter grab-and-go di depan, lounge kerja yang tenang di lantai atas.",
    image:
      "https://cdn.magicpatterns.com/uploads/25qBxPEzrPUA9iGsExATm9/Snapinsta.app_381969829_253206547170759_3485609706078817049_n_1080_(1).jpg",
    features: ["Dekat MRT Haji Nawi", "Konter grab-and-go", "Lounge kerja lantai atas", "Parkir sepeda"],
    openHour: 7,
    closeHour: 21,
    hoursLabel: "Setiap hari 07.00–21.00",
  },
];
